/* assets/swm26-modul-weinslider.js */
(() => {
  const roots = document.querySelectorAll('[data-swm26-ws]');
  if (!roots.length) return;

  const lockScroll = () => {
    document.documentElement.style.overflow = 'hidden';
  };

  const unlockScroll = () => {
    document.documentElement.style.overflow = '';
  };

  const openModal = (root, url) => {
    const modal = root.querySelector('[data-ws-modal]');
    const iframe = root.querySelector('[data-ws-modal-iframe]');
    if (!modal || !iframe || !url) return;

    modal.classList.remove('is-ready');
    iframe.src = 'about:blank';

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    lockScroll();

    if (iframe._wsOnLoad) {
      iframe.removeEventListener('load', iframe._wsOnLoad);
      iframe._wsOnLoad = null;
    }
    if (iframe._wsReadyTimer) {
      window.clearTimeout(iframe._wsReadyTimer);
      iframe._wsReadyTimer = null;
    }

    const onLoad = () => {
      iframe._wsReadyTimer = window.setTimeout(() => {
        modal.classList.add('is-ready');
      }, 350);

      iframe.removeEventListener('load', onLoad);
      iframe._wsOnLoad = null;
    };

    iframe._wsOnLoad = onLoad;
    iframe.addEventListener('load', onLoad);

    requestAnimationFrame(() => {
      iframe.src = url;
    });
  };

  const closeModal = (root) => {
    const modal = root.querySelector('[data-ws-modal]');
    const iframe = root.querySelector('[data-ws-modal-iframe]');
    if (!modal || !iframe) return;

    modal.classList.remove('is-open');
    modal.classList.remove('is-ready');
    modal.setAttribute('aria-hidden', 'true');

    if (iframe._wsReadyTimer) {
      window.clearTimeout(iframe._wsReadyTimer);
      iframe._wsReadyTimer = null;
    }

    if (iframe._wsOnLoad) {
      iframe.removeEventListener('load', iframe._wsOnLoad);
      iframe._wsOnLoad = null;
    }

    iframe.src = 'about:blank';
    unlockScroll();
  };

  const bindModalClose = (root) => {
    root.querySelectorAll('[data-ws-modal-close]').forEach((el) => {
      if (el.dataset.wsBoundClose === '1') return;
      el.dataset.wsBoundClose = '1';
      el.addEventListener('click', () => closeModal(root));
    });

    const modal = root.querySelector('[data-ws-modal]');
    if (!modal || modal.dataset.wsBoundBackdrop === '1') return;
    modal.dataset.wsBoundBackdrop = '1';

    modal.addEventListener('click', (e) => {
      if (e.target && e.target.classList && e.target.classList.contains('swm26-ws__modal-backdrop')) {
        closeModal(root);
      }
    });
  };

  const bindNutritionTriggers = (root, scope) => {
    const container = scope || root;

    container.querySelectorAll('button[data-nutrition-url]').forEach((btn) => {
      if (btn.dataset.wsBoundNutri === '1') return;
      btn.dataset.wsBoundNutri = '1';

      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        openModal(root, btn.getAttribute('data-nutrition-url'));
      });
    });

    container.querySelectorAll('a[href*="winestro.info/?s="]').forEach((a) => {
      if (a.dataset.wsBoundNutri === '1') return;
      a.dataset.wsBoundNutri = '1';

      a.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        openModal(root, a.getAttribute('href'));
      });
    });
  };

  const bindHardWinestroBlocker = (root) => {
    if (root.dataset.wsHardBound === '1') return;
    root.dataset.wsHardBound = '1';

    root.addEventListener(
      'click',
      (ev) => {
        const a = ev.target && ev.target.closest ? ev.target.closest('a[href*="winestro.info/?s="]') : null;
        if (!a) return;

        ev.preventDefault();
        ev.stopPropagation();
        openModal(root, a.getAttribute('href'));
      },
      true
    );
  };

  const fixTrackHeight = (root) => {
    const track = root.querySelector('[data-ws-track]');
    const slides = Array.from(root.querySelectorAll('[data-ws-slide]'));
    if (!track || !slides.length) return;

    const w = Math.ceil(track.getBoundingClientRect().width);
    if (!w) return;

    const measurer = document.createElement('div');
    measurer.style.position = 'absolute';
    measurer.style.left = '-99999px';
    measurer.style.top = '0';
    measurer.style.width = `${w}px`;
    measurer.style.visibility = 'hidden';
    measurer.style.pointerEvents = 'none';
    measurer.style.contain = 'layout style paint';
    root.appendChild(measurer);

    let maxH = 0;

    slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.remove('is-active', 'is-leaving', 'is-entering-left', 'is-entering-right');
      clone.style.position = 'static';
      clone.style.inset = 'auto';
      clone.style.opacity = '1';
      clone.style.visibility = 'visible';
      clone.style.pointerEvents = 'none';
      measurer.appendChild(clone);

      const h = clone.getBoundingClientRect().height;
      if (h > maxH) maxH = h;

      measurer.removeChild(clone);
    });

    root.removeChild(measurer);

    if (maxH > 0) {
      track.style.setProperty('--swm26-ws-track-h', `${Math.ceil(maxH)}px`);
    }
  };

  const debounce = (fn, ms) => {
    let t;
    return (...args) => {
      window.clearTimeout(t);
      t = window.setTimeout(() => fn(...args), ms);
    };
  };

  roots.forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-ws-slide]'));
    const btnPrev = root.querySelector('[data-ws-prev]');
    const btnNext = root.querySelector('[data-ws-next]');
    if (!slides.length) return;

    let index = slides.findIndex((s) => s.classList.contains('is-active'));
    if (index < 0) index = 0;

    const ANIM_MS = 340;
    let isAnimating = false;

    const setActive = (nextIndex, dir) => {
      if (isAnimating) return;
      isAnimating = true;

      const prev = slides[index];
      index = (nextIndex + slides.length) % slides.length;
      const next = slides[index];

      if (prev === next) {
        isAnimating = false;
        return;
      }

      // Clean states
      slides.forEach((s) => s.classList.remove('is-entering-left', 'is-entering-right'));

      const enterClass = dir === 'next' ? 'is-entering-right' : 'is-entering-left';

      // Next: sichtbar + Startzustand
      next.classList.add('is-active');
      next.classList.add(enterClass);

      // Prev: während der Animation ausfaden
      prev.classList.add('is-leaving');

      bindNutritionTriggers(root, next);

      // Force reflow, dann Startzustand entfernen -> animiert in "active"
      next.offsetHeight;
      next.classList.remove(enterClass);

      window.setTimeout(() => {
        prev.classList.remove('is-active');
        prev.classList.remove('is-leaving');
        isAnimating = false;
      }, ANIM_MS);
    };

    btnPrev?.addEventListener('click', () => setActive(index - 1, 'prev'));
    btnNext?.addEventListener('click', () => setActive(index + 1, 'next'));

    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') setActive(index - 1, 'prev');
      if (e.key === 'ArrowRight') setActive(index + 1, 'next');
      if (e.key === 'Escape') closeModal(root);
    });
    root.tabIndex = 0;

    bindModalClose(root);
    bindHardWinestroBlocker(root);
    bindNutritionTriggers(root, slides[index]);

    const doFix = () => fixTrackHeight(root);
    doFix();

    const imgs = root.querySelectorAll('img');
    let pending = 0;
    imgs.forEach((img) => {
      if (img.complete) return;
      pending++;
      img.addEventListener(
        'load',
        () => {
          pending--;
          if (pending <= 0) doFix();
        },
        { once: true }
      );
    });

    window.addEventListener('load', doFix, { once: true });
    window.addEventListener('resize', debounce(doFix, 120));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-swm26-ws]').forEach((root) => {
      const modal = root.querySelector('[data-ws-modal]');
      if (modal && modal.classList.contains('is-open')) closeModal(root);
    });
  });
})();